import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import React, { type FC } from 'react'

import { StaticAsset } from '../static-asset/static-asset'
import { StarsLabelMapping } from '../static-asset/static-assets.interface'

export const StarsLabelImage: FC<{
  label: string
}> = ({ label }) => {
  const assetOptions: AssetOptionsContextProps = {
    width: '2.8125rem',
    height: '2.8125rem',
    minSvgWidth: '2.8125rem',
    maxSvgHeight: '2.8125rem',
    objectFit: 'contain',
    alt: '',
  }

  const labelImage = StarsLabelMapping[label]
  if (!labelImage) {
    return null
  }

  return (
    <AssetOptionsContext.Provider value={assetOptions}>
      <StaticAsset name={labelImage} />
    </AssetOptionsContext.Provider>
  )
}
